import './oiLoading.css';
import React from 'react'

const oiLoading = (props) => {
    return (
        <div>
            <div className="oi-loading-box">
                <img className="oi-loading" src={`${process.env.PUBLIC_URL}` + "/imgs/loading.svg"} alt="Loading" />
                <p className="oi-loading-text">Carregando</p>
            </div>
        </div>
    );
};

export default oiLoading;


// WEBPACK FOOTER //
// ./src/components/oiLoading/oiLoading.js